import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import PapaParse from "papaparse";
import { UploadIcon } from "../../atoms/Icons";
import Button from "../../atoms/Button/index";
import FieldTooltip from "../Tooltip/index";

export interface Props {
  onFileLoaded: (values: string[][] | string[]) => void;
  label?: string;
  type?: string;
  tooltipText?: string;
  isDisabled: boolean;
  flattenOutput?: boolean;
  shouldClear?: boolean;
}

const FileUpload = ({
  onFileLoaded,
  label = "Upload file",
  type = "csv",
  tooltipText,
  flattenOutput = false,
  isDisabled,
  shouldClear = false,
}: Props) => {
  const [csvData, setCSVData] = useState<string[][] | string[]>([]);
  const inputFileRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (csvData.length > 0) {
      onFileLoaded(csvData);
    }
  }, [csvData]);

  useEffect(() => {
    if (shouldClear) {
      setCSVData([]);
      if (inputFileRef.current) {
        inputFileRef.current.value = "";
      }
    }
  }, [shouldClear]);

  const onBtnClick = () => {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const file = event.target.files?.[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const contents = e.target?.result;
          if (typeof contents === "string") {
            const parsedData = PapaParse.parse(contents).data;
            if (Array.isArray(parsedData)) {
              if (flattenOutput) {
                setCSVData(parsedData.flatMap((row: any) => row.map(String)));
              } else {
                setCSVData(parsedData.map((row: any) => row.map(String)));
              }
            }
          }
        } catch (error) {
          // Handle the error, e.g., display an error message or log it
          console.error("Error parsing CSV file:", error);
        }
      };

      reader.readAsText(file);
    }
  };

  return isDisabled && tooltipText ? (
    <FieldTooltip text={tooltipText} placement="top">
      <div>
        <input
          type="file"
          id="invite-csv"
          ref={inputFileRef}
          onChange={(e) => handleFileChange(e)}
          accept={`.${type}`}
          style={{ display: "none" }}
        />
        <Button
          variant="linkLight"
          disabled={isDisabled}
          className="items-center text-sm text-neutral-600"
          onClick={onBtnClick}
          iconLeft={<UploadIcon size={18} />}
        >
          {label}
        </Button>
      </div>
    </FieldTooltip>
  ) : (
    <div>
      <input
        type="file"
        id="invite-csv"
        ref={inputFileRef}
        onChange={(e) => handleFileChange(e)}
        accept={`.${type}`}
        style={{ display: "none" }}
      />
      <Button
        variant="linkLight"
        disabled={isDisabled}
        onClick={onBtnClick}
        iconLeft={<UploadIcon size={18} />}
      >
        {label}
      </Button>
    </div>
  );
};

export default FileUpload;
